import { useMemo } from "react";
import { FilterProps } from "react-table";

import { SingleSelectFilter } from "@/components/elements/DataTable";
import { IntegrationLogoBox } from "@/integrations";

import { RowData } from "../columns";

export function ConnectorFilter({
  column: { filterValue, setFilter, preFilteredRows },
}: FilterProps<RowData>) {
  const options = useMemo(() => {
    const optionsMap = new Map<
      string,
      {
        value: string;
        label: string;
        count: number;
        icon?: React.ReactNode;
      }
    >();
    preFilteredRows.forEach((row) => {
      const option = row.original.destinationConnection;
      if (optionsMap.has(option.id)) {
        optionsMap.get(option.id)!.count += 1;
      } else {
        optionsMap.set(option.id, {
          value: option.id,
          label: option.label,
          count: 1,
          icon: (
            <IntegrationLogoBox id={row.original.destinationIntegrationId} />
          ),
        });
      }
    });
    return [...optionsMap.values()].sort((a, b) =>
      a.label.localeCompare(b.label),
    );
  }, [preFilteredRows]);

  const currentValue =
    options.find((option) => option.value === filterValue) || null;

  return (
    <SingleSelectFilter
      value={currentValue}
      options={options}
      onChange={(value) => {
        setFilter(value.value);
      }}
      onClear={() => setFilter(undefined)}
      placeholder="All connectors"
      name="Connector"
    />
  );
}
